<template>
    <div
        class="row"
        :class="rowClasses"
    >
        <slot />
    </div>
</template>

<script>
    /**
    * Component
    */
    export default {
        name: 'row',
        props: {
            collapse: {
                type: Boolean,
                required: false,
                default: false
            },
            align: {
                type: String,
                required: false,
                default: null
            },
            fullHeight: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        computed: {
            rowClasses () {
                return {
                    'full-height': this.fullHeight,
                    'collapse no-pad': this.collapse,
                    'align-left': this.align === 'left',
                    'align-right': this.align === 'right',
                    'align-stretch': this.align === 'stretch'
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/Row.vue